(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.querySelector('.header-wrapper');
      this.headerInner = this.querySelector('.header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.inlineMenu = this.querySelector('.header__inline-menu');
      this.desktopMenuToggle = this.querySelector('.header__desktop-menu-toggle');
      this.desktopMenuOpen = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onDesktopMenuToggle = this.toggleDesktopMenu.bind(this);
      this.onDesktopBreakpointChange = this.handleDesktopBreakpointChange.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.mediaQuery.addEventListener('change', this.onDesktopBreakpointChange);
      this.desktopMenuToggle?.addEventListener('click', this.onDesktopMenuToggle);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mediaQuery.removeEventListener('change', this.onDesktopBreakpointChange);
      this.desktopMenuToggle?.removeEventListener('click', this.onDesktopMenuToggle);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.closeDesktopMenu();
        requestAnimationFrame(this.reset.bind(this));
      }

      this.syncDesktopMenuState(scrollTop);
      this.currentScrollTop = scrollTop;
    }

    handleDesktopBreakpointChange(event) {
      if (!event.matches) this.closeDesktopMenu();
      this.syncDesktopMenuState(window.pageYOffset || document.documentElement.scrollTop);
      this.setHeaderHeight();
    }

    toggleDesktopMenu() {
      if (!this.mediaQuery.matches || !this.header.classList.contains('scrolled-past-header')) return;

      this.desktopMenuOpen = !this.desktopMenuOpen;
      this.headerInner?.classList.toggle('header--desktop-nav-open', this.desktopMenuOpen);
      this.headerWrapper?.classList.toggle('header-wrapper--desktop-nav-open', this.desktopMenuOpen);
      this.header.classList.toggle('menu-open', this.desktopMenuOpen);
      this.desktopMenuToggle?.setAttribute('aria-expanded', String(this.desktopMenuOpen));

      if (!this.desktopMenuOpen) {
        this.closeMenuDisclosure();
      }

      this.setHeaderHeight();
    }

    closeDesktopMenu() {
      if (!this.desktopMenuOpen && !this.headerInner?.classList.contains('header--desktop-nav-open')) return;

      this.desktopMenuOpen = false;
      this.headerInner?.classList.remove('header--desktop-nav-open');
      this.headerWrapper?.classList.remove('header-wrapper--desktop-nav-open');
      this.header.classList.remove('menu-open');
      this.desktopMenuToggle?.setAttribute('aria-expanded', 'false');
      this.closeMenuDisclosure();
      this.setHeaderHeight();
    }

    syncDesktopMenuState(scrollTop) {
      if (!this.headerInner) return;

      const isDesktop = this.mediaQuery.matches;
      const isScrolled =
        isDesktop &&
        (scrollTop > this.headerBounds.top || this.header.classList.contains('scrolled-past-header'));

      this.headerInner.classList.toggle('header--is-scrolled', isScrolled);

      if (!this.inlineMenu || !this.desktopMenuToggle) return;

      if (!isDesktop || !isScrolled) {
        this.closeDesktopMenu();
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sitemap"] && !Shopify.designMode) return;
  try {
    
  class SitemapAccordion extends HTMLElement {
    constructor() {
      super();
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.onChange = this.syncState.bind(this);
    }

    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.sitemap__group'));
      this.isSimple = this.dataset.layout === 'simple';
      this.mediaQuery.addEventListener('change', this.onChange);
      this.syncState();

      this.querySelectorAll('.sitemap__jump-link').forEach((anchor) => {
        anchor.addEventListener('click', () => {
          const id = anchor.getAttribute('href').slice(1);
          const target = this.querySelector('#' + CSS.escape(id));
          if (target && target.tagName === 'DETAILS' && !this.mediaQuery.matches) {
            target.open = true;
          }
        });
      });
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.onChange);
    }

    syncState() {
      const isOpen = this.isSimple || this.mediaQuery.matches;
      this.groups.forEach((group) => {
        group.open = isOpen;
      });
    }
  }

  if (!customElements.get('sitemap-accordion')) {
    customElements.define('sitemap-accordion', SitemapAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
